<template>
  <div class="flex">
    <NFormGroup
      label="Email"
      required
    >
      <NInput
        placeholder="phojrengel@gmail.com"
        leading="i-heroicons-envelope-20-solid"
      />
    </NFormGroup>
  </div>
</template>
